<div id="geography-lab" class="inner-page py-5">
  <div class="container px-lg-5">

    <!-- Header Section -->
    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-orange mb-2" style="color: #f48020;">Geography Lab</h1>
      <h4 class="fw-semibold text-dark mb-4">"Mapping the World, Understanding Our Earth"</h4>
      <p class="lead text-muted mx-auto" style="max-width: 900px; line-height: 1.8; text-align: justify;">
        The Geography Laboratory at Shah Satnam Ji Girls College is a state-of-the-art facility designed to provide students with hands-on experience in geographical analysis, spatial planning, and earth sciences. Our lab is equipped with modern tools and charts to facilitate deep conceptual learning.
      </p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: #1c5c3e; border: none; opacity: 1;">
    </div>

    <!-- Content Card -->
    <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">
      
      <!-- Key Features -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Advanced Lab Equipment & Maps</h5>
      <p class="text-muted mb-3">Our lab boasts a rich collection of maps, topographical sheets, and meteorological instruments including:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Meteorological Instruments:</strong> Barometers, wet and dry bulb thermometers, rain gauges, and wind vanes for studying weather patterns.</li>
        <li class="mb-2"><strong>Spatial Modeling Tools:</strong> Modern standard globes, 3D relief maps, contour models, and geographical charts.</li>
        <li class="mb-2"><strong>Topographical Sheets:</strong> Extensive collection of Survey of India toposheets for spatial analysis and map work.</li>
        <li class="mb-2"><strong>Surveying Instruments:</strong> Prismatic compasses, chain tapes, plane tables, and leveling instruments for fieldwork.</li>
      </ul>

      <!-- Practical Curricula -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Practical Training & Cartography</h5>
      <p class="text-muted mb-3">We ensure our students receive comprehensive practical knowledge to prepare them for higher studies and research:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Cartographic Drafting:</strong> Hands-on sessions for map projections, scaling, and contour representation.</li>
        <li class="mb-2"><strong>Weather Interpretation:</strong> Reading, analyzing, and plotting weather data and reports.</li>
        <li class="mb-2"><strong>Field Surveying Camps:</strong> Annual practical survey camps to teach physical measurements and real-world data collection.</li>
      </ul>

      <!-- Career Opportunities -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Nurturing Future Spatial Experts</h5>
      <p class="text-muted mb-5" style="text-align: justify; line-height: 1.8;">
        Through extensive practical training, we prepare our students for diverse roles in urban planning, cartography, GIS analysis, meteorological services, environmental consultancy, and academic research. 
      </p>

      <!-- Geography Lab Gallery Section -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Lab Gallery Showcase</h5>
      <div class="row g-3 justify-content-center mb-5">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of geographyImages">
          <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
            <img [src]="img" alt="Geography Lab Infrastructure" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
            <div class="gallery-overlay d-flex align-items-center justify-content-center">
              <span class="zoom-icon"><i class="fas fa-search-plus"></i> View Lab</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Alert Banner -->
      <div class="p-4 rounded-4 mt-5 text-center" style="background-color: #fcece3; border: 1px solid #ffd8c3;">
        <h5 class="fw-bold mb-2" style="color: #e06c00;">"Geography is the subject which holds the key to our future."</h5>
        <p class="mb-0 fw-semibold text-muted" style="font-size: 15px;">Discover the patterns of our planet in a facility designed for academic excellence.</p>
      </div>

    </div>

    <!-- Fullscreen Backdrop-Blurred Lightbox -->
    <div class="lightbox-backdrop d-flex align-items-center justify-content-center animate-fade-in" *ngIf="activeLightboxImage" (click)="closeLightbox()">
      <div class="lightbox-content position-relative" (click)="$event.stopPropagation()">
        <button class="btn-close-lightbox" (click)="closeLightbox()">&times;</button>
        <img [src]="activeLightboxImage" class="lightbox-img img-fluid rounded-3" alt="Fullscreen Geography Lab View">
      </div>
    </div>

  </div>
</div>

